/**
 * ehr#682 (PROGRESS-NOTE V141 V86 / V87): a progress note's Comment history (body.reviewLog), kept
 * across rounds. Pure, so the API and the editor read one rule.
 *
 * - The editor adds an entry as it happens, with an empty `at` and its own id.
 * - The server stamps a new entry with who and when, keeps one per id, and never lets a save
 *   change or drop an entry already kept.
 */
import { REVIEW_LOG_KINDS, REVIEW_LOG_MAX, } from './clinical-notes.js';
const KINDS = new Set(REVIEW_LOG_KINDS);
/** The entries from a stored body or a request (anything malformed is left out). */
export function readReviewLog(v) {
    if (!Array.isArray(v))
        return [];
    return v.filter((e) => !!e &&
        typeof e === 'object' &&
        typeof e.id === 'string' &&
        e.id !== '' &&
        KINDS.has(e.kind) &&
        typeof e.at === 'string');
}
/**
 * The entries to keep when one side saves: the stored ones as they are, then each new entry sent
 * (an empty `at`, an id not kept yet) stamped with this user, now and the round. Entries sent
 * with a time are ones the server stamped before, so they are never taken from the request.
 * Past REVIEW_LOG_MAX the oldest go.
 */
export function mergeReviewLog(stored, sent, me) {
    const out = [...(stored ?? [])];
    const ids = new Set(out.map((e) => e.id));
    for (const e of sent ?? []) {
        if (e.at !== '' || ids.has(e.id) || !KINDS.has(e.kind))
            continue;
        ids.add(e.id);
        out.push({
            id: e.id,
            kind: e.kind,
            ...(e.section ? { section: e.section.slice(0, 48) } : {}),
            ...(e.text ? { text: e.text.slice(0, 2000) } : {}),
            by: me.by,
            at: me.at,
            round: me.round,
        });
    }
    return out.slice(-REVIEW_LOG_MAX);
}
/** Two kept lists joined (the first's entries win an id both have), oldest first, capped. */
export function joinReviewLogs(a, b) {
    const ids = new Set(a.map((e) => e.id));
    return [...a, ...b.filter((e) => !ids.has(e.id))].slice(-REVIEW_LOG_MAX);
}
/** A new entry as the editor makes it (the server stamps who and when). */
export function newLogEntry(kind, o) {
    return {
        id: o.id,
        kind,
        ...(o.section ? { section: o.section } : {}),
        ...(o.text && o.text.trim() ? { text: o.text.trim().slice(0, 2000) } : {}),
        by: o.by,
        at: '',
        round: o.round,
    };
}
//# sourceMappingURL=reviewLog.js.map